var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"text-center summary-card mb-3",attrs:{"no-body":""}},[_c('b-card-body',[_c('div',{staticClass:"summary-value"},[_vm._v(_vm._s(_vm.formattedValue))]),_c('div',{staticClass:"summary-title"},[_vm._v(_vm._s(_vm.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }